// auth.js
export const LOGOUT = 'LOGOUT';
export const SAVE_TOKEN = 'SAVE_TOKEN';
export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const UPDATE_USER = 'UPDATE_USER';

// lang.js
export const SET_LOCALE = 'SET_LOCALE';

// resource.js
export const FETCH_RESOURCES_SUCCESS = 'FETCH_RESOURCES_SUCCESS';
export const FETCH_RESOURCES_FAILURE = 'FETCH_RESOURCES_FAILURE';
export const UPDATE_RESOURCE = 'UPDATE_RESOURCE';
export const SET_DEFAULT_RESOURCE = 'SET_DEFAULT_RESOURCE';
export const SET_CREATED_RESOURCES = 'SET_CREATED_RESOURCES';
export const DELETE_DEFAULT_RESOURCE = 'DELETE_DEFAULT_RESOURCE';
export const SET_WALLKIT_RESOURCE = 'SET_WALLKIT_RESOURCE';

// user.js
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const UPDATE_PLANS = 'UPDATE_PLANS';
export const FETCH_USERS_FAILURE = 'FETCH_USERS_FAILURE';

// currency.js
export const SET_CURRENCY = 'SET_CURRENCY';
export const SET_CURRENCY_LOADING = 'SET_CURRENCY_LOADING';


// data.js
export const SET_MAILCHIMP_INTERESTS = 'SET_MAILCHIMP_INTERESTS';
export const SET_MAILCHIMP_INTERESTS_LOADING = 'SET_MAILCHIMP_INTERESTS_LOADING';
export const SET_CAMPAIGN_MONITOR_INTERESTS = 'SET_CAMPAIGN_MONITOR_INTERESTS';
export const SET_CAMPAIGN_MONITOR_INTERESTS_LOADING = 'SET_CAMPAIGN_MONITOR_INTERESTS_LOADING';
export const SET_PLANS = 'SET_PLANS';
export const SET_PLANS_LOADING = 'SET_PLANS_LOADING';
export const SET_COUNTRIES = "SET_COUNTRIES";
export const SET_COUNTRIES_LOADING = "SET_COUNTRIES_LOADING";

